export default __webpack_public_path__ + "static/company-bikeindex-2239c3969043beffdc934a75b82ed426.png";